import {TextThemes} from 'components/design-guide';
import {Colors} from 'styles/Colors';

// no theme defaults to nearBlack which is what the base color is.
export const generateTheme = (textTheme?: TextThemes) => {
  switch (textTheme) {
    case TextThemes.INFO:
      return Colors.BROWN_GREY;
    case TextThemes.SUCCESS:
      return Colors.SUCCESS_GREEN;
    case TextThemes.WARNING:
      return Colors.WARNING_RED;
    case TextThemes.DRAG:
      return Colors.AMICA_ORANGE;
    default:
      return Colors.NEAR_BLACK;
  }
};
